// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1uwe2","title":"ClientReferral_title__Hc7f-","itemText":"ClientReferral_itemText__zT3sZ"};